import { useState } from 'react';
import { type ResolvedPreconfiguredResponse } from '../../PreconfiguredMessages/AllMessages/utils';

export type SelectedPreconfiguredMessage = {
  message: ResolvedPreconfiguredResponse;
  isSending: boolean;
} | null;

const usePreconfiguredMessageActions = () => {
  const [isAllMessagesVisible, setIsAllMessagesVisible] = useState(false);
  const [selectedPreconfiguredMessage, setSelectedPreconfiguredMessage] =
    useState<SelectedPreconfiguredMessage>(null);

  const handleMessageAction = (
    selectedMessage: ResolvedPreconfiguredResponse,
    isSending: boolean,
  ) => {
    setIsAllMessagesVisible(false);
    setSelectedPreconfiguredMessage({ message: selectedMessage, isSending });
  };

  return {
    isAllMessagesVisible,
    setIsAllMessagesVisible,
    selectedPreconfiguredMessage,
    setSelectedPreconfiguredMessage,
    onCopyToChat: (msg: ResolvedPreconfiguredResponse) =>
      handleMessageAction(msg, false),
    onSendMessage: (msg: ResolvedPreconfiguredResponse) =>
      handleMessageAction(msg, true),
  };
};

export default usePreconfiguredMessageActions;
